import React from 'react';
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {useUser} from "../../../hooks/useUser";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import NewOrganizationContactPointModal from "./NewOrganizationContactPointModal";
import EditOrganizationContactPointModal from "./EditOrganizationContactPointModal";
import {useTableModals} from "../../../hooks/useTableModals";
import DeleteModal from "../../../components/common/modals/DeleteModal";

const cols = [
    {
        accessor:"contactPointSystemCode.display",
        Header:"System",
    },
    {
        accessor:"contactPointUseCode.display",
        Header:"Use",
    },
    {
        accessor:"value",
        Header:"Value"
    },
    {
        accessor:"effectiveFrom",
        Header:"Effective From",
        Cell: DateCell
    },
    {
        accessor:"effectiveTo",
        Header:"Effective To",
        Cell:DateCell
    }
]
const OrganizationContactPoints = ({contactPoints, organizationId, contactPointSystemCodes, contactPointUseCodes}) => {
    const mutation = graphql`
        mutation OrganizationContactPointsDeleteMutation($id: ID!) {
            deleteNode(input: {id: $id}) {
                deletedNodeId @deleteRecord
                owner {
                    ... on Organization {
                        id
                        contactPoints {
                            ...OrganizationContactPoints_ContactPoints
                        }}}}}`
    const data = useFragment(graphql`
        fragment OrganizationContactPoints_ContactPoints on OrganizationContactPoint @relay(plural: true) {
            id
            contactPointSystemCode {
                id
                display
            }
            contactPointUseCode {
                id
                display
            }
            value
            effectiveFrom
            effectiveTo
        }`,contactPoints)
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols,"OrganizationContactPoint.Update", "OrganizationContactPoint.Delete");

    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
                                 >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Contact Points"}
                                         table
                                         showNew={hasPermission("OrganizationContactPoint.Create")}
                        />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName="bg-200 text-900 text-nowrap align-middle"
                                      rowClassName="align-middle white-space-nowrap"
                                      tableProps={{
                                          size: 'sm',
                                          striped: true,
                                          className: 'fs--1 mb-0 overflow-hidden'}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table/>
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewOrganizationContactPointModal organizationId={organizationId} 
                                              onClose={newModal.onClose} 
                                              contactPointSystemCodes={contactPointSystemCodes} 
                                              showModal={newModal.showModal} 
                                              contactPointUseCodes={contactPointUseCodes}
            />
            {selected && <EditOrganizationContactPointModal onClose={editModal.onClose} 
                                               showModal={editModal.showModal} 
                                               selectedContactPoint={selected}
                                               contactPointSystemCodes={contactPointSystemCodes}
                                               contactPointUseCodes={contactPointUseCodes}
            />}
            {selected && <DeleteModal showModal={deleteModal.showModal}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Contact Point"}
                                      mutation={mutation}
                                      id={selected.id}
            >
                <p>This action cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
export default OrganizationContactPoints